// extracted by mini-css-extract-plugin
export var section = "_404-module--section--2yPds";
export var pulse = "_404-module--pulse--PLX3k";
export var inner = "_404-module--inner--3huEq";
export var title = "_404-module--title--39x3Q";
export var subtitle = "_404-module--subtitle--1fE9i";